// Central data-testid constants for the app
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const TESTIDS = {
  // Nav
  nav: "site-nav",
  navBrand: "nav-brand",
  navLinkHome: "nav-link-home",
  navLinkAbout: "nav-link-about",
  navLinkServices: "nav-link-services",
  navLinkSellGold: "nav-link-sell-gold",
  navLinkSellSilver: "nav-link-sell-silver",
  navLinkGCR: "nav-link-gcr",
  navLinkLoanVsSell: "nav-link-loan-vs-sell",
  navLinkMortgage: "nav-link-mortgage",
  navLinkBranches: "nav-link-branches",
  navLinkContact: "nav-link-contact",
  navCallCta: "nav-call-cta",
  navMobileToggle: "nav-mobile-toggle",

  // Rate ticker
  rateTicker: "live-rate-ticker",
  rateRefresh: "rate-refresh-btn",

  // Hero
  heroSection: "hero-section",
  heroWhatsappCta: "hero-whatsapp-cta",
  heroCallCta: "hero-call-cta",

  // Rate calculator
  calcSection: "rate-calculator",
  calcWeight: "calc-weight-input",
  calcPurity: "calc-purity-select",
  calcMetal: "calc-metal-select",
  calcResult: "calc-result",
  calcResetBtn: "calc-reset-btn",
  calcWhatsappBtn: "calc-whatsapp-btn",

  // Services
  servicesSection: "services-section",
  serviceCard: (id) => `service-card-${id}`,

  // Trust
  trustSection: "trust-section",

  // Testimonials
  testimonialsSection: "testimonials-section",
  testimonialCard: (id) => `testimonial-card-${id}`,

  // Branches
  branchesSection: "branches-section",
  branchCard: (id) => `branch-card-${id}`,
  branchMap: (id) => `branch-map-${id}`,
  branchDirections: (id) => `branch-directions-${id}`,

  // Contact
  contactSection: "contact-section",
  contactCallBtn: "contact-call-btn",
  contactWhatsappBtn: "contact-whatsapp-btn",

  // Floating
  floatWhatsapp: "float-whatsapp-btn",
  floatCall: "float-call-btn",

  // Footer
  footer: "site-footer",
};
